module.exports = __webpack_public_path__ + "img/insert-products.5165d56e.png";